export default 
{    
    App:{
        Title:"ROOM SERVICE",
        BackHome:"Back to homepage",
        Logout:"Log out",
        ChangePassword:"Change my password",
        CreateUser:"Create client file",
        CreateUserAccess:"Create client account",   
        Reception:"Reception",
        ListCustomer:"Guest list in room",
        RoomService:"Room service",
        OrderManagement:"Order management",
        OrderHistory:"Order history",
        AddOrder:"Add Order",
        Administration:"Administration",
        UserAccount:"User account",
        MailSkin:"Mail skin",
        MailTemplate:"Mail template",
        QrCode:"QrCode",
        AlertAddCart:"Warning"
    },
    Reception:{
        FirstName:"First name",
        LastName:"Name",
        MailAdress:"Mail address",
        VillaSuiteNb:"N° Suite / Villa",
        TelNb:"Mobile phone number",
        DateOfStay:"Date of stay",
        SendRequest:"Send request",
        SendConfirmation:"Validate and send confirmation",
        SendLoginEmail:"Send login email",
        AutoConnect:"Auto connect",
        CustomerAccess:"Client access terre blanche hotel",    
        Valid:"Valid",
        WaitingValidation:"Waiting for validation",
        GustInRoom:"Guests in room",
        CreateFile:"Create a customer file",
        AlertDelete:"Do you really want to delete the stay",
        CustomerToCome:"Coming stay",
        CheckIn:"CheckIn",
        CheckOut:"CheckOut",
        AlertCreate: "Your request has been taken into account. You will receive a validation of your account by e-mail",
        AlertCreateTitle: "Request sent",
    },
    User:{
        FirstName:"First name",
        LastName:"Last name",
        MailAdress:"Mail address",
        SendLoginEmail:"Send login email",
        AlertDelete:"Do you confirm the deletion of user '{name}'"
    },
    Cart:{                
        SeeCart:"See cart",
        YourCart:"YOUR CART",
        Continue:"Continue",
        Comments:"Comments, allergies, various",
        UnitPrice:"Unit price",
        Quantity:"Quantity",
        NbGuest:"Number of guests*",
        NbGuestInfos:"Specify the number of seats desired (mandatory)",
        TimeDelivery:"Desired delivery time*",
        TotalTTC: "Total Price",
        PartTVA: "Including VAT",
        PriceService:"Net price, service included",
        Add:"Add",
        Remove:"Remove",
        ClientName:"Customer name",
        FinalizeOrder:"In order to finalize the order",
        FinalizeOperator:"an operator will contact you.",
        FinalizeChoice:"Please choose how to be contacted.",
        InOrderToValidate:"In order to validate your order, login or create an access",
        InOrderToValidateEnterStay:"In order to validate your order enter your date of stay",
        AlertRemoveItem:"Would you like to completely remove this product from your cart?",
        Clear:"Empty your cart",
        AlertClear:"Would you like to completely empty your cart?",
        AlertDelevery:"In order to validate your order you must choose a valid delivery window",
        AlertDeleveryTitle:"Choose a delivery window",
        AlertOrderSavedTitle:"Thank you",
        AlertOrderSaved:"Your order has been registered",
        AlertProductMix:"Please empty your basket beforehand.<br/> The selection of mixed dishes <br/> (breakfast / dinner, lunch) <br/> is not possible.",
        AlertProductMixTitle:"Warning"
    },
    Dish:{
        HideAllergens:"Hide allergens",
        ShowAllergens:"Show allergens",
        Allergens:"Allergens",        
        SelectOptions:"select the composition of your options",
        IncludedTitle:"Included in your",
        Included:"included",
        CravingMore:"Craving more",
        SupplementTitle:"Supplement to the card",
        YourSupplementTitle:"Your supplement to the card | Your supplements to the card",
        SelectedCooking:"Selected cooking",
        ChooseCooking:"Choose cooking",           
        AlertEggCookingTitle:"Choice of cooking your eggs",
        AlertEggCooking:"You must choose the method of preparation of your eggs",     
        ChooseCookingTitle:"CHOOSE YOUR COOKING",        
        SelectedFlavor:"Selected variant",
        ChooseFlavor:"Choose the variant",
        ChooseFlavorTitle:"CHOOSE",           
        SelectedSideDish:"Selected side dish",     
        ChoiceSideDish:'Included side dish | Included side dishes'   ,            
        BeyondSideDish:"beyond, supplement by side dish of",
        SideDish:"Side dish in supplement at",        
        AlertSideDishesTitle: "You seem to have forgotten something!",
        AlertSideDishes: "You have not selected all of the included sides. You have {n} choices. Would you like to continue anyway?",
        SnackAddCart:"{plat} has been added to cart for a total amount of {prix} | {n} {plat} have been added to cart for a total amount of {prix}",   
        SnackAddBreakfastSupplement:"{plat} has been added as a supplement for a total amount of {prix} | {n} {plat} have been added as a supplement for a total amount of {prix}",
        Edit:"Edit",        
        MissingOptionItemAlert:"A selection of '{dish}' is missing | {n} selections of '{dish}' are missing",
        MissingOptionAlertTitle: "You seem to have forgotten something!",
        MissingOptionAlert:"<ul class='mb-2'> <li> {message} </li> </ul> do you still want to validate your menu '<strong> {dish} </strong>'",
        BtnCookingTime:"Cooking time*",
        CookingTime:"Cooking time: {time}",
        ChefChoice:"Chef's choice",        
        AlertTimeCooking:"It seems that you have not selected any cooking times <br/> <br/> <strong> Let the Chef choose for you? </strong>",
        ModifyConfig:"Change my choices",
        RecapBreakfast:"Breakfast menu summary",
        DesiredQty:"Quantité souhaitée",
        RecapEgg:"Summary of your egg configuration"
    },
    ChangePassword:{
        Title:"Change my password",
        OldPassword:"Old Password",
        NewPassword:"New Password",
        Modify:"Send change",
        ChangePasswordProgress:"Change password in progress",
        ChangePasswordSuccess:"Change password success",
        ChangePasswordError:"Change password error"
    },
    Global:{
        Yes:"true",
        No:"false",
        Warning:"Warning",
        Ok:"Ok",
        Validate:"Validate",
        Delete:"Delete",
        Cancel:"Cancel",
        Save:"Save",
        Close:"Close",
        Choose:"Choose",
        Language:"Language",
        Edit:"Edit",
        With:"Avec",
        Without:"Sans", 
        WeAre:"We are",
        Welcome:"Welcome",
        DiscoverCards:"Discover all of our catering menus",
        Between:"between",
        And:"and",
        Full:"Complet",
        Loaded:"loaded",
        UpdateDeliverySlots:"Update delivery slots",
        Today:"Today",
        Tomorrow:"Tomorrow",
        Yesterday:"Yesterday",
        FormatPeriode:"from {start} to {end}",
        download:"Download",
        Days:"d",
        Back:"Back",
        ConfirmDelete:"Confirm deletion",
        Reset:"Reset"
    },
    Horaires:{
        Breakfast:"Breakfast",
        BreakfastHours:"6:00 AM - 11:00 AM",
        Lunch:"Lunch",
        LunchHours:"11:00 AM - 5:00 PM",
        Dinner:"Dinner",
        DinnerHours:"5:00 PM - 11:00 PM",
        NightMenu:"Night menu available from 6:00 PM to 5:00 AM"
    },
    Icon:{
        omelette:"omelette",
        'omelette-blanc':"omelette (egg whites only)",        
        brouilles:"scrambled",
        'brouilles-blanc':"scrambled (egg whites only)",
        auPlat:"fried eggs",
        poches:"poached",
        coque:"soft-boiled",
        dur:"hard boiled"
    },       
    Menu: {
        Cart:"Room service menu",
        Print:"Print room service menu"
    },
    LangSwitcher:{
        Tooltip:"Language"
    },    
    Login: {
        Login: "Login",
        Email: "Email",
        Password: "Password",
        LoginAction: "Login",
        SendRequest:"Send request",
        CancelRequest:"Back to identification",
        AuthenticationProgress: "Identification in progress",
        AuthenticationSuccess: "Successful identification",
        AuthenticationError: "incorrect identification",
        PassForgottenSuccess:"Request sent successfully",
        PassForgottenProgress:"Demand in progress",
        PassForgottenError:"Error: Account and email do not match",
        ForgotPassword:"Forgot your password",
        InfosLogin:"You can identify yourself automatically with the link you received by email, or request a password change with the link below",
        CreateAccess:"Create access",
        InfosAccount:"Your account is not yet activated",
        EnterStayDate:"Enter your date of stay",
        StayDate:"your date of stay"
    },
    Commande:{
        BreakFastToComme:"Breakfast coming",
        DinerToComme:"Lunch / dinner to come",
        Passed:"Passed order",
        AddDish:"Add dishes to order",
        Date:"Order date and time",
        SendMail: "Resend confirmation by e-mail",
        Language:"Language",
        AlertDelete:"Are you sure you want to delete the order",
        Validate: "Validate and send confirmation by e-mail",
    }

}
